// Stable TanStack Query keys. Hooks and mutations must use these so
// cache reads and invalidations stay in sync. See src/client/data/README.md.

export const consoleKeys = {
  all: ["console"] as const,
  status: () => ["console", "status"] as const,
  ghlStatus: () => ["console", "ghl-status"] as const,
  sites: () => ["console", "sites"] as const,
  ingestStatus: () => ["console", "ingest-status"] as const,
  customers: () => ["console", "customers"] as const,
  authConfig: () => ["console", "auth-config"] as const,
};
